import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import Projects from "./components/Projects";
import Skills from "./components/sections/Skills";
import Journey from "./components/sections/Journey";
import Contact from "./components/sections/Contact";
import Preloader from "./components/Preloader";
import ScrollProgress from "./components/ui/ScrollProgress";
import BackToTop from "./components/ui/BackToTop";

function App() {
  const [loading, setLoading] = useState(true);

  /* Hold the scroll position while the intro curtain is up. */
  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  return (
    <>
      <AnimatePresence>
        {loading && <Preloader onDone={() => setLoading(false)} />}
      </AnimatePresence>

      <ScrollProgress />
      <Navbar />

      <main className="relative bg-ink">
        <Hero />
        <About />
        <Projects />
        <Skills />
        <Journey />
        <Contact />
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}

export default App;
